import type { SupportedCountry } from "@config";
import type { ICountryAdapter } from "../../types";
import type { MapSearchType } from "@repo/maps";
import type { CurrencyType } from "@repo/database";

export abstract class BaseCountryAdapter implements ICountryAdapter {
  abstract code: SupportedCountry;

  abstract currency: CurrencyType;

  abstract areaMeasurementUnit: ICountryAdapter["areaMeasurementUnit"];

  abstract isZipCode(input: string): boolean;

  abstract getLocationTypesForSegments(
    segments: string[],
  ): MapSearchType[] | undefined;
}
